import React from "react";
import styled from "styled-components";
import { RangeKey } from "./logQuery";

// Sáu lựa chọn theo đúng thứ tự đặc tả — nhãn hiển thị tiếng Anh ngắn, đúng
// bảng màu (xanh #0f62fe, xám #cbd5e1/#334155) mà StationPortalLogs.tsx đang
// dùng cho nút Apply/Export, tránh sinh thêm một bảng màu thứ ba trong màn này.
const RANGE_OPTIONS: Array<{ key: RangeKey; label: string }> = [
	{ key: "15m", label: "15m" },
	{ key: "1h", label: "1h" },
	{ key: "24h", label: "24h" },
	{ key: "7d", label: "7d" },
	{ key: "30d", label: "30d" },
	{ key: "custom", label: "Custom" },
];

// Segmented control gọn, dày — các nút liền khối trong một khung viền, không
// phải các nút pill rời rạc kiểu landing page.
const Group = styled.div`
	display: inline-flex;
	border: 1px solid #cbd5e1;
	border-radius: 10px;
	overflow: hidden;
`;

const OptionButton = styled.button<{ $active: boolean }>`
	font: inherit;
	font-size: 13px;
	font-weight: 600;
	line-height: 1;
	padding: 8px 14px;
	border: none;
	border-right: 1px solid #cbd5e1;
	cursor: pointer;
	background: ${(props) => (props.$active ? "#0f62fe" : "#fff")};
	color: ${(props) => (props.$active ? "#fff" : "#334155")};

	&:last-child {
		border-right: none;
	}

	&:hover {
		background: ${(props) => (props.$active ? "#0f62fe" : "#f1f5f9")};
	}
`;

export default function TimeRangePicker(props: { value: RangeKey; onChange: (next: RangeKey) => void }) {
	return (
		<Group
			role="group"
			aria-label="Khoảng thời gian">
			{RANGE_OPTIONS.map((option) => {
				const active = option.key === props.value;
				return (
					<OptionButton
						key={option.key}
						type="button"
						$active={active}
						aria-pressed={active}
						onClick={() => {
							// Bấm lại chính khoảng đang chọn thì bỏ qua: vỏ màn hình xoá con
							// trỏ và gọi lại API mỗi lần onChange bắn ra, bấm trùng sẽ gọi thừa.
							if (active) return;
							props.onChange(option.key);
						}}>
						{option.label}
					</OptionButton>
				);
			})}
		</Group>
	);
}
